import { token } from '@cp/shared/di';
import { SpiderService } from './spiderService';

export const SPIDER_SERVICE_TOKEN = token<SpiderService>('SpiderService');
